let isMobileApp = false
export default () => isMobileApp
export const setMobileApp = value => isMobileApp = value